export const MESSAGE_RECEIVED = 'received';
export const MESSAGE_SENT = 'sent';
